import smoothscroll from 'smoothscroll-polyfill';

// ---------------------------//
//   ===== GO TO SECTION ====
// ---------------------------//

const goToAnchor = () => {
	smoothscroll.polyfill();

	const allAnchorLinks = document.querySelectorAll('a[href*=\\#]');
	let offset = 30;

	const header = document.querySelector('.header');
	if (header !== null) {
		offset += header.clientHeight;
	}

	const navSticky = document.querySelector('.sticky-submenu');
	if (navSticky !== null) {
		offset += navSticky.clientHeight;
	}

	if (allAnchorLinks.length) {
		for (const anchorLink of allAnchorLinks) {
			anchorLink.addEventListener('click', e => {
				let windowUrl = window.location.href.split('#')[0];
				let url = e.currentTarget.href.split('#');

				let baseUrl = url[0];
				let hash = url[1];
				//si l'element est sur une autre page
				if (baseUrl === windowUrl && hash !== 'tarteaucitron') {
					history.pushState(null, null, `#${hash}`);
					e.preventDefault();

					anchorHref(baseUrl, hash, e);
				}
			});
		}
	}

	const anchorHref = (url, hash, event) => {
		//si on ne clique pas sur tarte au citron

		let positionEl = 0;

		const anchorID = document.getElementById(hash);
		if (anchorID != null) {
			positionEl = anchorID.getBoundingClientRect().top + window.scrollY;

			scroll({
				top: positionEl - offset,
				behavior: 'smooth',
			});
		} else {
			// si l'ancre ne se trouve pas sur la page
			console.info("l'identifiant n'a pas été trouvé, on redirige sur l'url");
			document.location.href = url;
		}
	};

	if (window.location.hash.length !== 0) {
		let hash = window.location.hash.substring(1);
		if (hash !== 'tarteaucitron') {
			anchorHref(window.location.href, hash);
		}
	}
};

export default goToAnchor;
